import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountingCoinsBills1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "accounting-coins-bill" }),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "a",
			cx: 6.75,
			cy: 14.25,
			rx: 6,
			ry: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,14.25v6c0,1.657,2.686,3,6,3s6-1.343,6-3v-6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.75,17.25c0,1.657-2.686,3-6,3s-6-1.343-6-3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,15.75h6a1.5,1.5,0,0,0,1.5-1.5v-12a1.5,1.5,0,0,0-1.5-1.5H2.25a1.5,1.5,0,0,0-1.5,1.5V9.757"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9,8.25a3,3,0,1,1,4.979,2.255"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M4.5,4.125a.375.375,0,1,1-.375.375A.375.375,0,0,1,4.5,4.125"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.5,11.625a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		})
	]
});
export default SvgAccountingCoinsBills1;
